import Practice from "app/models/practice"
import { createSelector } from "reselect"
import State from "../state"

export const loading = (state: State): boolean => state.practices.loading

export const getPractices = (state: State): Practice[] | undefined => state.practices.data

export const getSelectingPreparedPractices = createSelector(getPractices, (practices: Practice[] | undefined) => {
  if (!practices) {
    return []
  }
  return practices.map((practice: Practice) => ({
    value: practice.id,
    label: practice.name,
  }))
})
